const NAMESPACE = "archiveUtil";

const KEYS = {
    onFormsHeader: "onFormsHeader",
    onCommunicationsHeader: "onCommunicationsHeader",
    onDocumentTemplatesHeader: "onDocumentTemplatesHeader",

    isArchivedHeader: "isArchivedHeader",
    archiveText: "archiveText",
    unarchiveText: "unarchiveText",

    nameHeader: "nameHeader",
    typeHeader: "typeHeader",
    formulasTypeText: "formulasTypeText",
    formulasTypeNumeric: "formulasTypeNumeric",
    formulasTypeLogical: "formulasTypeLogical",
    formulasTypeDate: "formulasTypeDate",
    formulasTypeUnknown: "formulasTypeUnknown"
};

const MESSAGES = {
    [KEYS.onFormsHeader]: {
        value: "On Forms",
        comment: "Label for the On Forms search column."
    },
    [KEYS.onCommunicationsHeader]: {
        value: "On Communications",
        comment: "Label for the On Communications search column."
    },
    [KEYS.onDocumentTemplatesHeader]: {
        value: "On Document Templates",
        comment: "Label for the On Document Templates search column."
    },
    [KEYS.isArchivedHeader]: {
        value: "Is Archived",
        comment: "Label for the Is Archived column."
    },
    [KEYS.archiveText]: {
        value: "Archive",
        comment: "Label for the archive action."
    },
    [KEYS.unarchiveText]: {
        value: "Unarchive",
        comment: "Label for the unarchive action."
    },
    [KEYS.nameHeader]: {
        value: "Name",
        comment: "Label for the Name column."
    },
    [KEYS.typeHeader]: {
        value: "Type",
        comment: "Label for the Type column."
    },
    [KEYS.formulasTypeText]: {
        value: "Text",
        comment: "Label for the text formula type."
    },
    [KEYS.formulasTypeNumeric]: {
        value: "Numeric",
        comment: "Label for the numeric formula type."
    },
    [KEYS.formulasTypeLogical]: {
        value: "Logical",
        comment: "Label for the logical formula type."
    },
    [KEYS.formulasTypeDate]: {
        value: "Date",
        comment: "Label for the date formula type."
    },
    [KEYS.formulasTypeUnknown]: {
        value: "Unknown",
        comment: "Label for the unknown formula type."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
